import {ImputationAvanceCalculFinal} from "./imputation-avance-calcul-final";
import {AvanceCalculFinal} from "./avance-calcul-final";

/**
 * Résultat du calcul final des avances à imputer
 *
 * @author Laurent Convert
 * @date 24/04/2026
 */
export interface CalculFinal {
	idNdf: number;
	idModeRemb: number;
	modeImputation: number;
	deviseNote: string;
	deviseEntreprise: string;
	montantRembourseDevNote: number;
	montantRembourseDevEntrep: number;
	listeDeviseMontant: Array<DeviseMontant>;
	listeAvances: Array<AvanceCalculFinal>;
	imputationAvances: {[devise: string]: ImputationAvanceCalculFinal};
	montantFranchise: number;
	quantiteFranchise: number;
	uniteFranchise: string;
}

/**
 * Représentant le montant à imputer par devise
 */
export interface DeviseMontant {
	devise: string;
	montant: number;
	montantDevNdf: number;
	montantDevEntrep: number;
}

/**
 * Modes d'imputation
 */
export enum ModeImputation {
	/** Mode 1 : Imputation des dépenses en devise par les avances dans la même devise */
	MODE_IMPUTATION_1_MEME_DEVISE = 2,
	/** Mode 2 : Mode 1 + Solde des autres dépenses par les avances dans la devise de la note de frais */
	MODE_IMPUTATION_2_DEVISE_NOTE = 3,
	/** Mode 3 : Mode 2 + Solde des autres dépenses par toutes les autres avances disponibles */
	MODE_IMPUTATION_3_TOUTES_DEVISES = 4,
}